.base {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 180px;
  overflow: hidden;
  border-radius: var(--radius-lg);
  background: var(--bg-elevated);
  isolation: isolate;
}

/* The poster again, blown up and blurred into a backdrop. Anchored right and
   over-sized so the blur's soft edge never reaches the frame — a blurred image
   fades toward transparent at its bounds, which reads as a rendering fault. */
.backdrop {
  position: absolute;
  inset: -10%;
  width: 120%;
  height: 120%;
  object-fit: cover;
  object-position: 70% 25%;
  filter: blur(28px) saturate(1.25);
  opacity: 0.55;
  z-index: 0;
}

/* Two gradients: one flattens the left so text has a stable ground regardless
   of artwork, one darkens the whole field so the card never out-shouts the
   analysis below it. */
.scrim {
  position: absolute;
  inset: 0;
  z-index: 1;
  background:
    linear-gradient(90deg, var(--bg-card) 12%, rgba(0, 0, 0, 0.55) 55%, rgba(0, 0, 0, 0.25) 100%),
    linear-gradient(180deg, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.45));
}

.body {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: var(--space-5);
  padding: var(--space-5);
  width: 100%;
  min-width: 0;
}

.poster {
  width: 92px;
  height: 138px;
  flex-shrink: 0;
  object-fit: cover;
  border-radius: var(--radius-md);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.55);
}

.posterFallback {
  width: 92px;
  height: 138px;
  flex-shrink: 0;
  border-radius: var(--radius-md);
  background: var(--bg-active);
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 92px;
  height: 92px;
  flex-shrink: 0;
  border-radius: var(--radius-md);
  background: var(--bg-card);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.45);
}

.text {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-width: 0;
}

.title {
  margin: 0;
  font-family: var(--font-sans);
  font-size: var(--text-2xl);
  font-weight: var(--weight-bold);
  letter-spacing: var(--tracking-tight);
  line-height: 1.1;
  color: #fff;
  text-shadow: 0 2px 12px rgba(0, 0, 0, 0.6);
}

.meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0;
  margin: 0;
  font-size: var(--text-sm);
  color: var(--text-secondary);
}

.sep {
  margin: 0 var(--space-2);
  opacity: 0.45;
}

/* The one qualitative signal the title endpoint carries. Coloured by level so
   EXCEPTIONAL doesn't read the same as AVERAGE at a glance. */
.badge {
  align-self: flex-start;
  margin-top: var(--space-1);
  padding: 3px var(--space-3);
  border-radius: var(--radius-pill);
  border: 1px solid currentColor;
  font-size: var(--text-xs);
  font-weight: var(--weight-semi);
  letter-spacing: var(--tracking-caps);
  text-transform: uppercase;
  color: var(--text-secondary);
}

.badge[data-level='exceptional'] {
  color: var(--brand-green);
}

.badge[data-level='outstanding'] {
  color: var(--brand-teal, var(--data-4));
}

.badge[data-level='good'] {
  color: var(--data-2);
}

@media (max-width: 720px) {
  .base {
    min-height: 0;
  }

  .body {
    gap: var(--space-4);
    padding: var(--space-4);
  }

  .poster,
  .posterFallback {
    width: 64px;
    height: 96px;
  }

  .logo {
    width: 64px;
    height: 64px;
  }

  .title {
    font-size: var(--text-xl);
  }
}
